import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import mainStyle from './assets/style/main.scss'
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// vue-validate
import { ValidationProvider,extend } from 'vee-validate/dist/vee-validate.full.esm';
import { ValidationObserver } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules';
// vue mask
import VueTheMask from 'vue-the-mask'
// Vuesax
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
// vue paginate
import Paginate from 'vuejs-paginate'
// vue select
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';



import "../src/design/app.scss";

import store from '@/state/store'

import App from './App.vue'

import { initFirebaseBackend } from './authUtils'
import i18n from './i18n'

import { configureFakeBackend } from './helpers/fake-backend';

import tinymce from 'vue-tinymce-editor'

import "./filters";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}

Vue.use(VueAxios, axios)
Vue.component('tinymce', tinymce)
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false
// Vue Mask
Vue.use(VueTheMask)
Vue.use(Vuesax)


Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)

// vue-validate
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
import { messages } from 'vee-validate/dist/locale/ru.json';

Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule],
    message: messages[rule]
  });
});
// vue paginate
Vue.component('paginate', Paginate)
// vue select
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';

Vue.mixin({
  methods: {
    checkRoleAcl(role) {
      let has = this.$store.dispatch('auth/checkRole', role).then(res => {
        return res;
      })
      return has;
    },
    checkRolesAcl(roles) {
      let has = this.$store.dispatch('auth/checkRoles', roles).then(res => {
        return res;
      })
      return has;
    },
    checkPermissionAcl(permission) {
      const allPermissions = this.$store.state.auth.permissions;
      if(this.$store.state.auth.roles.includes(this.$store.state.auth.roles.superRole)) return true;

      if(!allPermissions.length) return false;

      return allPermissions.includes(permission);
    },
    checkPermissionsAcl(permissions) {
      if(permissions.includes('no-permission')) return true;
      const allPermissions = this.$store.state.auth.permissions;
      if(allPermissions.length === 0) return false;
      return permissions.some(permission => allPermissions.includes(permission));
    }
  }
})


new Vue({
  router,
  store,
  i18n,
  mainStyle,
  render: h => h(App)
}).$mount('#app')
